// Live Assist trigger detection (Operation Friday Ready P1-4). Pure and
// dependency-free so the server-side eval harness can exercise it directly.

// Ignore very short fragments ("Yes?", "Hm?") that carry no answerable content.
const MIN_TRIGGER_CHARS = 12;

const OBJECTION_RE = /\bobject(?:ion|ed|s)?\b/i;
const INTERROGATIVE_RE =
  /^(?:what|why|how|when|where|who|whom|which|do|does|did|is|are|was|were|can|could|will|would|should|shall|have|has|had|tell (?:me|the court|us)|explain|take (?:me|us) to|isn't|aren't|wasn't|weren't|don't|doesn't|didn't|can't|couldn't|won't|wouldn't|shouldn't|haven't|hasn't)\b/i;

/** True when a finalized utterance reads as a question or objection aimed at
 *  the operator. Deterministic and cheap — runs on every final turn. */
export function isTriggerUtterance(text: string): boolean {
  const t = text.trim();
  if (t.length < MIN_TRIGGER_CHARS) {
    return false;
  }
  return /\?\s*$/.test(t) || OBJECTION_RE.test(t) || INTERROGATIVE_RE.test(t);
}
